import {useEffect, useState} from 'react';
import {getBADIntroApi} from 'helpers/services/api/bookADrive';

/**
 * Whether the BFF says to introduce Book a Driver to the active location: the
 * bad_orders_tooltip feature is on and the location has fewer than five Book a
 * Driver orders, all time (counted by the book-a-driver-service). false while
 * loading, when skipped, or when the call fails, so nothing shows on doubt.
 */
const useBookADriverIntro = (locationId, enabled) => {
  const [showNew, setShowNew] = useState(false);

  useEffect(() => {
    setShowNew(false);
    if (!enabled || !locationId) return undefined;

    let cancelled = false;
    getBADIntroApi(locationId)
      .then((response) => {
        if (!cancelled) setShowNew(response?.data?.data?.showNew === true);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [locationId, enabled]);

  return showNew;
};

export default useBookADriverIntro;
